import { createTheme, lightThemePrimitives } from 'baseui';

export const theme = createTheme(
    {
        ...lightThemePrimitives,
        primaryFontFamily: "sans-serif",
        primary: '#0059ff',
        primary700: '#0047cc',
    },
    {
        name: 'custom-typography',
        typography: {
            primaryFontFamily: "sans-serif",
            font11: {
                fontFamily: "sans-serif",
                fontSize: '11px',
                fontWeight: 400,
                lineHeight: 1.5,
            },
            fontBold11: {
                fontFamily: "sans-serif",
                fontSize: '11px',
                fontWeight: 700,
                lineHeight: 1.5,
            },
            font12: {
                fontFamily: "sans-serif",
                fontSize: '12px',
                fontWeight: 400,
                lineHeight: 1.5,
            },
            fontBold12: {
                fontFamily: "sans-serif",
                fontSize: '12px',
                fontWeight: 700,
                lineHeight: 1.5,
            },
            font13: {
                fontFamily: "sans-serif",
                fontSize: '13px',
                fontWeight: 400,
                lineHeight: 1.5,
            },
            fontBold13: {
                fontFamily: "sans-serif",
                fontSize: '13px',
                fontWeight: 700,
                lineHeight: 1.5,
            },
            font14: {
                fontFamily: "sans-serif",
                fontSize: '14px',
                fontWeight: 400,
                lineHeight: 1.5,
            },
            fontBold14: {
                fontFamily: "sans-serif",
                fontSize: '14px',
                fontWeight: 700,
                lineHeight: 1.5,
            },
            font16: {
                fontFamily: "sans-serif",
                fontSize: '16px',
                fontWeight: 400,
                lineHeight: 1.5,
            },
            fontBold16: {
                fontFamily: "sans-serif",
                fontSize: '16px',
                fontWeight: 700,
                lineHeight: 1.5,
            },
            font18: {
                fontFamily: "sans-serif",
                fontSize: '18px',
                fontWeight: 400,
                lineHeight: 1.5,
            },
            fontBold18: {
                fontFamily: "sans-serif",
                fontSize: '18px',
                fontWeight: 700,
                lineHeight: 1.5,
            },
            font21: {
                fontFamily: "sans-serif",
                fontSize: '21px',
                fontWeight: 400,
                lineHeight: 1.5,
            },
            fontBold21: {
                fontFamily: "sans-serif",
                fontSize: '21px',
                fontWeight: 700,
                lineHeight: 1.5,
            },
            font24: {
                fontFamily: "sans-serif",
                fontSize: '24px',
                fontWeight: 400,
                lineHeight: 1.5,
            },
            fontBold24: {
                fontFamily: "sans-serif",
                fontSize: '24px',
                fontWeight: 700,
                lineHeight: 1.5,
            },
            font30: {
                fontFamily: "sans-serif",
                fontSize: '30px',
                fontWeight: 400,
                lineHeight: 1.5,
            },
            fontBold30: {
                fontFamily: "sans-serif",
                fontSize: '30px',
                fontWeight: 700,
                lineHeight: 1.5,
            },
            font350: {
                fontSize: '14px',
                fontWeight: 700,
                lineHeight: '24px',
            },
            font450: {
                fontSize: '15px',
                fontWeight: 700,
                lineHeight: '22px',
            },
        },
        sizing: {
            scale25: '25px',
            scale30: '30px',
        },
        borders: {
            borderE6: {
                borderColor: '#E6E6E6',
                borderStyle: 'solid',
                borderWidth: '1px',
            },
            borderEA: {
                borderColor: '#eaeaea',
                borderStyle: 'solid',
                borderWidth: '1px',
            },
        },
        colors: {
            primary: '#0059ff',
            primary700: '#0047cc',
            primary400: '#003399',
            red400: '#ff2841',
            red700: '#cc1f33',
            greyE6: '#E6E6E6',
            textDark: '#0a0a0a',
            textNormal: '#6b6b6b',
            borderE6: '#E6E6E6',
            borderF1: '#f1f1f1',
            backgroundF7: '#f8f8f8',
            lightGreen: '#00bcb6',
            warning: '#ffab00',
            blue400: '#0059ff',
            purple400: '#8A6AFC',
        },
        buttonBorderRadius: '3px',
    }
);
